import { useRef, useEffect } from 'react';

/**
 * Hook to get previous ref value.
 * @param {Boolean} value - React component props
 * Uses - `const prevFocus = usePreviousRef(Boolean(focus));`
 */
function usePreviousRef(value) {
    const ref = useRef();
    // Store current value in ref
    useEffect(() => {
        ref.current = value;
    }, [value]);
    // Only re-run if value changes
    // Return previous value (happens before update in useEffect above)
    return ref.current;
}
export default usePreviousRef;
